@if (control) {
    <div [ngClass]="{
            'label-input-container': true,
            'label-position-top': hasLabel && !inlineLabel,
            'label-position-right': hasLabel && inlineLabel }">
        @if (hasLabel) {
            <label class="form-field-label"
                   [ngClass]="{'inlined': inlineLabel, 'clickable': hasClickableLabel}"
                   [for]="control.id"
                  >
                <ng-content select="app-label" />
                @if (control.required) {
                    <app-required-marker />
                }
            </label>
        }

        <div class="input-row">
            <div [ngClass]="{
            'input-wrapper': true,
            'styled': control.isStyled,
            'alert': control.errorState,
            'highlight': highlight,
            'focus': control.hasFocus }">
                @if (icon) {
                    <app-icon [name]="icon" class="icon-start" />
                }
                <ng-content select="[appInput]" />
                @if (isPassword) {
                    <app-icon class="icon-password"
                              [name]="passwordIcon"
                              (click)="onTogglePasswordVisibility()" />
                }
            </div>
        </div>

        <div class="after-input-slot">
            <ng-content select="[slot=after-input]" />
        </div>
    </div>

    <div class="form-field-hint">
        <ng-content select="app-form-field-hint" />
    </div>

    <ng-content />

    @if (control.errorState) {
        <div class="form-field-error">
            <ng-content select="app-form-field-error" />
        </div>
    }
}
